import apiClient from './Request'
import { baseUrls } from './../const'
import swal from 'sweetalert'

export default {
  // Create a new backtest job
  createBackTest(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['reportBaseUrl'] + '/api/v4/job/create',
      data: data
    })
  },

  // Get list of all backtest jobs
  getBackTestList(data) {
    return apiClient.get(
      baseUrls['reportBaseUrl'] +
        '/api/v4/job/all?' +
        new URLSearchParams(data).toString()
    )
  },

  // Get Algorithm Options
  getAlgorithmOptions() {
    return apiClient.get(baseUrls['reportBaseUrl'] + '/api/v4/job/algorithms')
  },

  // Get specific backtest job details
  getBackTestDetail(jobId) {
    return apiClient.get(baseUrls['reportBaseUrl'] + '/api/v4/job/' + jobId)
  },

  // Get job status (for progress polling)
  getBackTestStatus(jobId) {
    return apiClient.get(
      baseUrls['reportBaseUrl'] + '/api/v4/job/' + jobId + '/status'
    )
  },

  // Get raw data slice for inspection tool
  getRawSlice(jobId, start, end, offset, fileUrl) {
    return apiClient.get(
      baseUrls['reportBaseUrl'] +
        '/api/v4/job/' +
        jobId +
        '/slice?start=' +
        start +
        '&end=' +
        end +
        (offset !== undefined ? '&offset=' + offset : '') +
        (fileUrl ? '&fileUrl=' + encodeURIComponent(fileUrl) : '')
    )
  },

  GetAllPatientsForConfig() {
    return apiClient.get(
      baseUrls['reportBaseUrl'] + '/api/v4/membership/getallpatientsforconfig'
    )
  },

  // Fetch chart data from CSV URL
  async fetchChartData(chartUrl) {
    try {
      const response = await fetch(chartUrl, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store'
      })
      if (!response.ok) {
        throw new Error(`Failed to fetch chart data: ${response.status}`)
      }
      const blob = await response.blob()
      const csvText = await blob.text()
      if (!csvText || !csvText.trim()) {
        throw new Error('Empty CSV response')
      }
      return this.parseCSV(csvText)
    } catch (error) {
      swal({
        icon: 'error',
        title: 'Error',
        text: 'Error fetching chart data'
      })
      throw error
    }
  },

  // Parse CSV data
  parseCSV(csvText) {
    if (!csvText) return { headers: [], data: [] }
    const sanitized = csvText.replace(/^\uFEFF/, '').replace(/\r/g, '')
    const lines = sanitized.split('\n').filter(line => line.trim() !== '')
    if (lines.length === 0) return { headers: [], data: [] }
    const headers = lines[0].split(',')
    const data = []

    for (let i = 1; i < lines.length; i++) {
      if (lines[i].trim()) {
        const values = lines[i].split(',')
        const row = {}
        headers.forEach((header, index) => {
          row[header.trim()] = values[index] ? values[index].trim() : null
        })
        data.push(row)
      }
    }

    return { headers, data }
  }
}
